import { render, staticRenderFns } from "./findPage.vue?vue&type=template&id=80c8eb24&scoped=true"
import script from "./findPage.vue?vue&type=script&lang=js"
export * from "./findPage.vue?vue&type=script&lang=js"
import style0 from "./findPage.vue?vue&type=style&index=0&id=80c8eb24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c8eb24",
  null
  
)

export default component.exports